export default (node) => {
  /**
   * Data + elements
   */
  const buttons = node.querySelectorAll('[data-resource-access]');

  /**
   * Functions
   */

  const handleClick = () => {
    // get current url
    const url = window.location.href;
    // save url to local storage
    localStorage.setItem('redirectUrl', url);
    document.location.href = '/account/login';
  };

  /**
   * Init
   */
  const init = () => {
    // Some code required for initializing this component
    buttons.forEach((button) => {
      button.addEventListener('click', handleClick);
    });
  };

  init();
};
